import { createSlice } from '@reduxjs/toolkit';
import {
  CreateUser,
  DeleteAdmin,
  EditAdmin,
  FetchAdminUsers,
  FetchAdminUsersAdvance,
  UploadProfileImage,
} from './adminServicesSync';

const adminSlice = createSlice({
  name: 'admin',
  initialState: {
    admin_users: [],
    message: '',
    loading: false,
    addLoading: false,
    normalLoading: false,
    adminDeleteLoader: false,
    error: null,
    success: false,
    authLimit: 10,
    authSkip: 0,
    userDetails: {},
    uploadprofileLoader: false,
    profileImageDetails: {},
    editAdminId: '',
  },
  reducers: {
    resetState: (state) => {
      state.loading = false;
      state.addLoading = false;
      state.normalLoading = false;
      state.adminDeleteLoader = false;
      state.error = null;
      state.success = false;
      state.message = '';
      state.authLimit = 10;
      state.authSkip = 0;
      state.userDetails = {};
      state.uploadprofileLoader = false;
      state.profileImageDetails = {};
      state.editAdminId = '';
    },

    updateAdminSkip: (state, { payload }) => {
      state.authSkip = payload;
    },

    updateAllAdminLimit: (state, { payload }) => {
      state.authLimit = payload;
    },

    updateUserDetails: (state, { payload }) => {
      state.userDetails = payload;
    },

    updateAdminId: (state, { payload }) => {
      state.editAdminId = payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(CreateUser.pending, (state) => {
        state.loading = true;
      })
      .addCase(CreateUser.fulfilled, (state, { payload }) => {
        let addUser = {
          ...state.admin_users,
          docs: [...state.admin_users.docs, payload.data],
        };

        state.admin_users = addUser;
        state.loading = false;
        state.success = true;

        const addButton = document.querySelector('[data-bs-dismiss="modal"]');

        if (addButton) {
          addButton.click();
        }
      })
      .addCase(CreateUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload.message;
      });

    builder
      .addCase(EditAdmin.pending, (state) => {
        state.loader = true;
      })
      .addCase(EditAdmin.fulfilled, (state, { payload }) => {
        console.log(payload?.data, 'season of work');

        const findIndex = state?.admin_users?.docs?.findIndex(
          (item) => item._id === payload?.data?._id
        );

        state?.admin_users?.docs?.splice(findIndex, 1, payload.data);

        state.admin_users = {
          ...state?.admin_users,
          docs: state?.admin_users?.docs,
        };
        state.loader = false;
        state.message = payload.message;
        state.editAdminId = '';
      })
      .addCase(EditAdmin.rejected, (state, { payload }) => {
        state.loader = false;
        state.message = payload.message;
        state.editAdminId = '';
      });

    builder
      .addCase(FetchAdminUsers.pending, (state) => {
        state.normalLoading = true;
        state.error = null;
      })
      .addCase(FetchAdminUsers.fulfilled, (state, action) => {
        state.normalLoading = false;
        state.message = action.payload.message;
        state.admin_users = action.payload?.data;
        state.authSkip = action.payload?.data?.page;
      })
      .addCase(FetchAdminUsers.rejected, (state, action) => {
        state.normalLoading = false;
        state.error = action.payload;
      });

    builder
      .addCase(FetchAdminUsersAdvance.pending, (state) => {
        state.addLoading = true;
        state.error = null;
      })
      .addCase(FetchAdminUsersAdvance.fulfilled, (state, action) => {
        state.addLoading = false;
        state.message = action.payload.message;
        state.admin_users = action.payload?.data;
        state.authSkip = action.payload?.data?.page;
      })
      .addCase(FetchAdminUsersAdvance.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action.payload;
      });

    builder
      .addCase(DeleteAdmin.pending, (state) => {
        state.adminDeleteLoader = true;
      })
      .addCase(DeleteAdmin.fulfilled, (state, { payload }) => {
        const filterData = state?.admin_users?.docs?.filter(
          (item) => item._id !== payload?.data?._id
        );

        let addUser = {
          ...state.admin_users,
          docs: filterData,
        };

        state.admin_users = addUser;

        state.adminDeleteLoader = false;
        state.message = payload.message;

        state.editAdminId = '';
      })
      .addCase(DeleteAdmin.rejected, (state, { payload }) => {
        state.adminDeleteLoader = false;
        state.message = payload.message;
        state.editAdminId = '';
      });

    builder
      .addCase(UploadProfileImage.pending, (state) => {
        state.uploadprofileLoader = true;
      })
      .addCase(UploadProfileImage.fulfilled, (state, { payload }) => {
        state.uploadprofileLoader = false;
        state.message = payload.message;
        state.profileImageDetails = payload.data;
      })
      .addCase(UploadProfileImage.rejected, (state, { payload }) => {
        state.uploadprofileLoader = false;
        state.message = payload?.message;
      });
  },
});

export const {
  resetState,
  updateAdminSkip,
  updateAllAdminLimit,
  updateUserDetails,
  updateAdminId,
} = adminSlice.actions;
export default adminSlice.reducer;
